"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JCB = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const JCB = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
}, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "jcb_svg__b",
  x1: "100%",
  x2: "3.381%",
  y1: "43.985%",
  y2: "43.985%"
}, /*#__PURE__*/_react.default.createElement("stop", {
  offset: "0%",
  stopColor: "#43C311"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "100%",
  stopColor: "#288C00"
})), /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "jcb_svg__d",
  x1: ".258%",
  x2: "101.258%",
  y1: "49.75%",
  y2: "49.75%"
}, /*#__PURE__*/_react.default.createElement("stop", {
  offset: "0%",
  stopColor: "#21469E"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "100%",
  stopColor: "#1E81EB"
})), /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "jcb_svg__f",
  x1: "100%",
  x2: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/_react.default.createElement("stop", {
  offset: "0%",
  stopColor: "#F42D3E"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "100%",
  stopColor: "#9C0017"
})), /*#__PURE__*/_react.default.createElement("path", {
  id: "jcb_svg__a",
  d: "M1.61 0c-.094 0-.187.003-.28.014-.359.04-.697.22-.94.498-.18.206-.306.46-.359.733-.026.134-.03.27-.03.405v1.472c0 .035-.007.038.03.038H1.756c.188 0 .378-.008.566.01a.99.99 0 0 1 .523.19c.21.165.296.451.224.714-.07.252-.276.421-.513.492a1.036 1.036 0 0 1-.079.02c-.015.003-.036.002-.05.01-.007.002-.025.007-.012.02.003.003.017.003.027.002h.01c.074.008.148.021.22.042.22.062.434.196.536.415.12.26.059.582-.136.783a.97.97 0 0 1-.58.267c-.107.013-.214.01-.321.01H.083c-.016 0-.063-.008-.076 0-.008.006-.005.013-.005.026v3.093c0 .006-.004.032 0 .036.004.006.043 0 .052 0H2.14c.343 0 .669-.091.946-.306.377-.292.6-.756.601-1.242V.004H1.98C1.866.004 1.75 0 1.634 0H1.61ZM.723 3.63c-.005.01 0 .034 0 .046v.604c0 .016-.008.072.004.08.01.007.051 0 .064 0H1.518a.4.4 0 0 0 .289-.113.377.377 0 0 0 .091-.341.36.36 0 0 0-.07-.146.376.376 0 0 0-.266-.136c-.049-.004-.098-.002-.147-.002H.734c-.006 0-.008 0-.011.008Zm.568 1.213H.723V5.611c0 .012-.005.039 0 .05.007.018.078.008.1.008H1.539a.478.478 0 0 0 .264-.057.432.432 0 0 0 .061-.665.406.406 0 0 0-.286-.104H1.292Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "jcb_svg__c",
  d: "M1.267.02c-.215.036-.42.121-.6.246A1.575 1.575 0 0 0 0 1.552V5.35c0 .028 0 .022.032.038l.105.05c.283.128.581.225.889.264.22.027.457.035.666-.055a.688.688 0 0 0 .37-.38.935.935 0 0 0 .056-.348V3.207c0-.01-.005-.04 0-.047.006-.01.058-.004.073-.004h1.227v1.791c0 .177-.026.356-.097.52a1.01 1.01 0 0 1-.326.406c-.34.255-.793.322-1.205.34a5.975 5.975 0 0 1-.884-.028A5.515 5.515 0 0 1 0 6.027V9.259c0 .005-.003.027 0 .03.007.008.062 0 .074 0H1.817c.257 0 .52.019.772-.046.439-.114.812-.432 1.002-.853.104-.232.139-.477.139-.73V0H1.607c-.114 0-.227.002-.34.02"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "jcb_svg__e",
  d: "M1.4.004a1.45 1.45 0 0 0-.47.112C.598.256.323.518.162.846a1.59 1.59 0 0 0-.16.696v2.017l.03-.027c.037-.03.075-.06.115-.087.247-.168.535-.262.824-.318a4.22 4.22 0 0 1 .715-.07c.235-.004.47.004.705.03.239.027.476.069.71.12l.087.02c.016.004.075.009.083.021.006.009 0 .043 0 .053V3.9a2.902 2.902 0 0 0-.905-.313c-.376-.062-.8-.06-1.125.171-.313.224-.422.621-.389.998.033.368.23.683.562.83.328.145.708.125 1.05.055a3.14 3.14 0 0 0 .807-.294V5.944c0 .01.006.046 0 .054-.008.012-.068.017-.083.02a6.44 6.44 0 0 1-.896.15 5.43 5.43 0 0 1-.71.018 3.894 3.894 0 0 1-.717-.09c-.31-.07-.62-.192-.864-.408V9.2c0 .007-.005.037 0 .043.01.013.094.002.114.002h1.533c.216 0 .436.012.651-.004.391-.029.761-.219 1.019-.524.246-.291.368-.66.368-1.045V.001H1.678L1.543 0c-.047 0-.095 0-.142.004"
})), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FFF",
  stroke: "#E7E9EF",
  strokeWidth: 0.5,
  d: "M22.995.75H3.005A2.25 2.25 0 0 0 .75 3.001v12.725c0 .62.253 1.184.661 1.592.408.407.972.66 1.594.66h19.99a2.25 2.25 0 0 0 2.255-2.252V3.001c0-.62-.253-1.183-.661-1.591a2.25 2.25 0 0 0-1.594-.66Z"
}), /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#jcb_svg__a",
  fill: "url(#jcb_svg__b)",
  transform: "translate(15.392 5)"
}), /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#jcb_svg__c",
  fill: "url(#jcb_svg__d)",
  transform: "translate(7 5)"
}), /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#jcb_svg__e",
  fill: "url(#jcb_svg__f)",
  transform: "translate(11.196 5)"
})));
exports.JCB = JCB;
JCB.displayName = "JCB";